import { useState } from "react"
import { useCreateSetupIntentMutation } from "./api"
import ReplaceCardForm from "./ReplaceCardForm"
import StripeElementsProvider from "./StripeElementsProvider"
import { useT } from "@/i18n"
import { Button } from "@/ui/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/ui/components/ui/dialog"
import { Skeleton } from "@/ui/components/ui/skeleton"

export default function ReplaceCardDialog() {
  const { t } = useT("money")
  const [open, setOpen] = useState(false)
  const [clientSecret, setClientSecret] = useState<string | null>(null)
  const [createSetupIntent] = useCreateSetupIntentMutation()

  const handleOpenChange = async (next: boolean) => {
    setOpen(next)
    // Create the SetupIntent lazily when the dialog first opens.
    if (next && !clientSecret) {
      const result = await createSetupIntent().unwrap()
      setClientSecret(result.clientSecret)
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger
        render={<Button variant="outline">{t("paymentMethod.replace")}</Button>}
      />
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("paymentMethod.replaceTitle")}</DialogTitle>
        </DialogHeader>
        {clientSecret ? (
          <StripeElementsProvider options={{ clientSecret }}>
            <ReplaceCardForm
              onSaved={() => {
                setOpen(false)
              }}
            />
          </StripeElementsProvider>
        ) : (
          <Skeleton className="h-48 w-full rounded-md" />
        )}
      </DialogContent>
    </Dialog>
  )
}
